module.exports = __webpack_public_path__ + "static/media/empty-state-course.b273c391.svg";